/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SiteNavDropdownImageModule_navigationModule = {
    readonly imageLinkData: {
        readonly path: string | null;
        readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
    } | null;
    readonly imageUrl: string | null;
    readonly imageTitlePrimary: string | null;
    readonly imageTitleSecondary: string | null;
    readonly imageHeight: string | null;
    readonly imageWidth: string | null;
    readonly " $refType": "SiteNavDropdownImageModule_navigationModule";
};
export type SiteNavDropdownImageModule_navigationModule$data = SiteNavDropdownImageModule_navigationModule;
export type SiteNavDropdownImageModule_navigationModule$key = {
    readonly " $data"?: SiteNavDropdownImageModule_navigationModule$data;
    readonly " $fragmentRefs": FragmentRefs<"SiteNavDropdownImageModule_navigationModule">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SiteNavDropdownImageModule_navigationModule",
  "type": "NavigationModule",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "imageLinkData",
      "storageKey": null,
      "args": null,
      "concreteType": "LinkData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "path",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SeoLink_linkData",
          "args": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageTitlePrimary",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageTitleSecondary",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageHeight",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageWidth",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '0ff3b2450399692f331aae9328e7c9c6';
export default node;
